import type { Contact } from "@lumika/shared";

/**
 * The best human-readable label for a contact. The server computes the
 * canonical priority (businessName → first+last → email → phone →
 * socialHandle → fallbackLabel → "Anonymous") and ships it as
 * `contact.displayName`; this function just reads it.
 *
 * The null fallback covers frontend optimistic constructions (ComposeDialog
 * "new" recipients, realtime-event objects) that may not yet have the
 * backend-computed field.
 */
export function contactDisplayName(contact: Contact): string {
  return contact.displayName ?? "Anonymous";
}
